import React from 'react';
import { Label } from 'react-bootstrap'

class FastTrackLabel extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        let bg = 'transparent';
        let type = '#000000';
        let labelContent = "";
        let fastTrack = this.props.value;
        
        if (fastTrack)
        {
            // Blue
            bg = '#3c8dbc';
            type = 'white';
            labelContent = "Fast Track";
        }
        else
        {
            // Grey
            bg = '#d2d6de';
            labelContent = "Normal Track";
        }

        return (
            <Label style={{ color: type, backgroundColor: bg, height: "34px" }}>
                <span>{labelContent}</span>
            </Label>
		);
	}
}

export default FastTrackLabel;


// WEBPACK FOOTER //
// ./src/areas/admin/shared/FastTrackLabel.js